module.exports = __webpack_public_path__ + "static/img/In-page.69cc0fc2.svg";